/**
 * This is a class that creates a wrapper around an instance of a service and injects it onto Vue. Note that
 * Vue will not install the same class twice, so we have a factory create classes for us.
 * @param service
 * @param name
 * @returns {VueServiceInstaller}
 */
export function installerFactory ({service, name}) {
  return class VueServiceInstaller {
    static install (Vue) {
      // Attach the service locator to the Vue global and each instance.
      [Vue, Vue.prototype].forEach(obj => Object.defineProperty(obj, name, {
        get () {
          return service;
        }
      }));
    }
  };
}



// WEBPACK FOOTER //
// ./src/shared/services/VueServiceInstaller.js